export default __webpack_public_path__ + "static/media/enterpriseSla.6af0507f.svg";